module.exports = __webpack_public_path__ + "static/media/iloop.77a908be.svg";